import { get, post } from '@/utils/request';

export const contacts = (params) => {
  return get('/api/v1/contacts', params);
};
export const contacts2 = (params) => {
  return get('/api/v1/contacts2', params);
};

export const contact_save = (params) => {
  return post('/api/v1/contact', params);
};

export const last_contact = (params) => {
  return get('/api/v1/last_contact', params);
};
